import React, {useEffect, useState} from "react";
import {DeleteButton} from "../../../helpers/ButtonHelper";
import {deleteItem, tableImageTag} from "../../../helpers/Api";
import {useMutation, useQuery} from "@apollo/client";
import ListTable from "../../shared/ListTable";
import {deleteMenuPlateMutation, getMenuPlates} from "./MenuQueries";
import EditMenuPlateModal from "./EditMenuPlateModal";
import AddMenuPlateModal from "./AddMenuPlateModal";
import PageSubTitle from "../../../layout/PageSubTitle";
import Loader from "../../shared/Loader";

const MenuPlatesList = ({ menu }) => {
  const [plates, setPlates] = useState([])
  const { loading, data, refetch } = useQuery(getMenuPlates, { variables: { menuId: menu.id } })
  const [deleteCall] = useMutation(deleteMenuPlateMutation, { refetchQueries: [getMenuPlates] })

  useEffect(() => {
    if (data)
      setPlates(data.menuItems)
  }, [data]);

  const header = <tr>
    <th>Ziua</th>
    <th>Perioada zilei</th>
    <th>Reteta</th>
    <th className='actions'>
      <AddMenuPlateModal showButton={true} menuId={menu.id} refetch={refetch}
                         onClose={refetch} />
    </th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>
        {item.day}
      </td>
      <td>
        {item.category.name}{item.category.time && `(${item.category.time})`}
      </td>
      <td>
        {tableImageTag(item.plate)}
        {item.plate.name}
      </td>
      <td className='actions'>
        {(!menu.clientId || !item.history) &&
          <EditMenuPlateModal menuId={menu.id} menuPlate={item}
                              showButton={true} refetch={refetch} onClose={refetch}
          />
        }
        {!menu.clientId &&
          <DeleteButton onClick={e => deleteItem(e, item.id, deleteCall)} />
        }
      </td>
    </tr>
  }

  return (
    <div className="container">
      <div className="row justify-content-md-center">
        <PageSubTitle title='Mesele meniului' />
        <div className="page-container col">
          {loading ?
            <Loader />
            :
            <ListTable data={plates} header={header} listItem={listItem}
                       searchFields={['day', 'plate.name', 'category.name']} />
          }
        </div>
      </div>
    </div>
  )
};

export default MenuPlatesList;
